// "productVariants" é inicializado em layout.liquid, e todos os arquivos liquid que montam
// um addFromTag populam este objeto com as variantes dos produtos em tela

//import Store from '../pages/institucional/stores';
import Info from '../components/product/content/info';

//import { formatMoney } from '../components/utilities';

const AddFromTag = {
  products: document.querySelectorAll('[data-add-from-tag]'),

  submitForm: function(currentProduct) {
    currentProduct.addEventListener('submit', event => {
      event.preventDefault();

      var $form = $(currentProduct);
      
      var $parent = $form.closest('[data-box-produto]');

      var respValidated = Info.validate($form);
      
      var $boxResponse = $parent.find('.msg-response');

      if (respValidated.validated) {
        Info.addItem($form, $parent);
      } else {
        //console.info('não foi');
        Info.setRespValidateProduct(respValidated, $form, $boxResponse);
      }
    })
  },

  init: function(update = false, variantsToUpdate = []) {    
    const { products, submitForm } = this;

    if (products.length > 0) products.forEach(product => {
      if (product.getAttribute('data-processed') == 'false') {
        submitForm(product);
        product.setAttribute('data-processed', true)
      }
    })
  }
}

export default AddFromTag;
